import React from 'react';

const SecondStepWhatsappTemplate = ({ values }) => {
  // Coupon or Voucher follow ups/early bird deadline
  const {
    client_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    coupon_code,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Hi ${client_name},` : `Hi [Recipient's Name],`}</p>
      <p>
        We noticed you haven't yet used your special discount voucher for{' '}
        {conference_short_name
          ? conference_short_name
          : `[Conference Short Name]`}
        . Don’t miss out on this exclusive opportunity to register and avail
        yourself of a discount!
      </p>

      <p>
        The conference will take place on{' '}
        {conference_from_date && conference_to_date
          ? `${conference_from_date} - ${conference_to_date}`
          : `[Conference from and to Date]`}{' '}
        at {conference_location ? conference_location : `[Conference Location]`}
        , and we’d love for you to join us.
      </p>
      <p>
        Use your coupon code {coupon_code ? coupon_code : `[Coupon Code]`} now
        and secure your spot at a discounted rate:{' '}
        {registration_link ? (
          <a
            href={registration_link}
            target="_blank"
            // rel="noopener noreferrer"
          >
            {registration_link}
          </a>
        ) : (
          `[Registration Link]`
        )}
      </p>

      <p>Let me know if you have any questions or need assistance!</p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default SecondStepWhatsappTemplate;
